import React, { useContext, useEffect, useState } from 'react';
import { FormModal } from '../Shared/form';
import tenantApi from '../../utils/api/tenant';
import { FormContext, FormSchemaFields } from '@sw-sw/lib-form';
import { UIControlType } from '@sw-sw/lib-form-control-types';
import ReactTooltip from 'react-tooltip';

function getSchema(features: any) {
  ReactTooltip.rebuild();
  return {
    name: {
      label: 'Add a Name',
      validation: {
        required: true,
      },
    },
    feature_ids: {
      label: 'Feature',
      controlType: UIControlType.customTagSelect,
      isMulti: true,
      openOnFocus: true,
      showSelectAll: true,
      options: features.map((feature: any) => ({
        value: feature.id,
        label: feature.name,
      })),
      labelKey: 'label',
      valueKey: 'value',
      showClearAll: true,
      validation: {
        required: true,
      },
    },
    description: {
      label: 'Description',
    },
    price: {
      label: 'Add a Cost',
      parse: (val: any) => parseFloat(val),
      validation: {
        required: true,
      },
      style: {
        flexBasis: '50%',
      },
    },
    as_per_project_usage: {
      label: 'As per Usage',
      controlType: UIControlType.select,
      options: [
        { value: true, label: 'Yes' },
        { value: false, label: 'No' },
      ],
      validation: {
        required: true,
      },
      style: {
        flexBasis: '50%',
      },
      toolTipOptions: {
        message:
          'This feature will incur charges based on its usage across projects. Charges will be calculated per project, based on the extent of usage of this feature.',
      },
    },
  };
}

export default function AddOnModal({
  isEditAction,
  selectedAddOnModalDetails,
  setAddOnList,
  setShowAddOnModal,
  setSelectedAddOnModalDetails,
}: {
  isEditAction: boolean;
  selectedAddOnModalDetails: any;
  setAddOnList: (list: any) => void;
  setShowAddOnModal: (show: boolean) => void;
  setSelectedAddOnModalDetails: (details: any) => void;
}) {
  const formContext = useContext(FormContext);

  const [features, setFeatures] = useState<any>([]);

  useEffect(() => {
    tenantApi.features.getAllFeaturesName().then((res) => {
      setFeatures(res);
    });
  }, []);

  const handleCreate = async (formData: any) => {
    const id = Math.floor(Math.random() * 1000);
    setAddOnList((prev: any) => [
      ...prev,
      {
        ...formData,
        feature_ids: formData.feature_ids.map((ele: any) => ele.value),
        tempId: id,
        is_enabled: true,
        is_deleted: false,
      },
    ]);
    setShowAddOnModal(false);
    setSelectedAddOnModalDetails(null);
  };

  const handleEdit = async (formData: any) => {
    setAddOnList((prev: any) => {
      const updatedList = prev.map((ele: any) => {
        if (
          (ele.id && ele.id === selectedAddOnModalDetails.id) ||
          (ele.tempId && ele.tempId === selectedAddOnModalDetails.tempId)
        ) {
          return {
            ...ele,
            ...formData,
            feature_ids: formData.feature_ids.map((ele: any) => ele.value),
          };
        }
        return {
          ...ele,
        };
      });
      return updatedList;
    });
    setShowAddOnModal(false);
    setSelectedAddOnModalDetails(null);
  };

  const handleDelete = async () => {
    setAddOnList((prev: any) => {
      const updatedList = prev.map((ele: any) => {
        if (
          (ele.id && ele.id === selectedAddOnModalDetails.id) ||
          (ele.tempId && ele.tempId === selectedAddOnModalDetails.tempId)
        ) {
          return {
            ...ele,
            is_deleted: true,
          };
        }
        return ele;
      });
      return updatedList;
    });
    setShowAddOnModal(false);
    setSelectedAddOnModalDetails(null);
  };

  if (!features || !features.length) return null;

  return (
    <FormModal
      modalProps={{
        title: isEditAction ? 'Edit Add On' : 'Create Add On',
      }}
      onSubmit={(formData) =>
        isEditAction ? handleEdit(formData) : handleCreate(formData)
      }
      onCancel={() => {
        setShowAddOnModal(false);
        setSelectedAddOnModalDetails(null);
      }}
      showDelete={isEditAction ? true : false}
      onDelete={() => handleDelete()}
    >
      <FormSchemaFields
        schema={getSchema(features)}
        formData={formContext.value}
        onChange={formContext.set}
        initialFormData={isEditAction ? selectedAddOnModalDetails : {}}
      />
    </FormModal>
  );
}
